import { createLogger } from 'redux-logger';

import config from '../configs/config';

const loggerOptions = {
    level: config.log.level !== 'none' ? config.log.level : 'log',
    predicate: (getState, action) => {
        if (config.log.level === 'none') {
            return false;
        }

        if (config.log.effects) {
            return true;
        }

        return !(/EFFECT_RESOLVED|EFFECT_TRIGGERED/).test(action.type);
    }
};

/**
 * Create redux logging middleware
 * @return {Function}      Redux logging middleware
 */
export const storeLogger = () => {
    if (config.log.redux) {
        return createLogger(loggerOptions);
    }

    return store => next => action => {};
};
